import { CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "@/assets/logo_perch.svg";

const rows = [
  { feature: "5G wireless service",                         perch: true, traditional: true },
  { feature: "Unlimited talk & text",                       perch: true, traditional: true },
  { feature: "Plans starting at $7.99/mo",                  perch: true, traditional: false },
  { feature: "No credit check to sign up",                  perch: true, traditional: false },
  { feature: "Credit building tools available",             perch: true, traditional: false },
  { feature: "Turn everyday payments into credit progress", perch: true, traditional: false },
  { feature: "No hidden fees or long-term contracts",       perch: true, traditional: false },
];

const ComparisonTable = () => {
  return (
    <section
      className="w-full py-16 lg:py-24 border-t"
      style={{ backgroundColor: '#1a1a1a', borderColor: 'rgba(255,255,255,0.08)' }}
    >
      <div className="container mx-auto px-4" style={{ maxWidth: '1200px' }}>

        {/* Header */}
        <div className="text-center mb-12 lg:mb-16">
          <p
            className="font-semibold uppercase mb-4"
            style={{ color: '#B0F18D', fontSize: '13px', letterSpacing: '0.15em' }}
          >
            Why Perch
          </p>
          <h2
            className="text-white font-bold mb-4"
            style={{
              fontSize: 'clamp(32px, 5vw, 60px)',
              lineHeight: 1.1,
              letterSpacing: '-0.04em',
            }}
          >
            Not all providers are created equal.
          </h2>
          <p
            className="mx-auto"
            style={{
              color: 'rgba(255,255,255,0.65)',
              fontSize: 'clamp(15px, 2vw, 18px)',
              lineHeight: 1.6,
              maxWidth: '640px',
            }}
          >
            Traditional providers take your money every month and give nothing back. Perch gives you tools to get more from your payments — including the ability to build credit over time.
          </p>
        </div>

        {/* Table */}
        <div
          className="rounded-2xl border overflow-hidden mx-auto w-fit"
          style={{ borderColor: 'rgba(255,255,255,0.1)' }}
        >
          {/* Column Headers */}
          <div
            className="grid grid-cols-[auto_120px_120px]"
            style={{ backgroundColor: 'rgba(255,255,255,0.05)' }}
          >
            <div className="p-5" />
            <div className="p-5 flex flex-col items-center justify-center border-l" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
              <img src={logo} alt="Perch Mobile" className="h-8 brightness-0 invert" />
            </div>
            <div className="p-5 flex flex-col items-center justify-center border-l" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
              <span className="text-sm font-semibold" style={{ color: 'rgba(255,255,255,0.4)' }}>
                Traditional Providers
              </span>
            </div>
          </div>

          {/* Feature Rows */}
          {rows.map(({ feature, perch, traditional }, index) => (
            <div
              key={feature}
              className="grid grid-cols-[auto_120px_120px] border-t"
              style={{
                borderColor: 'rgba(255,255,255,0.08)',
                backgroundColor: index % 2 === 0 ? 'rgba(255,255,255,0.02)' : 'transparent',
              }}
            >
              <div className="p-5 flex items-center">
                <span style={{ color: 'rgba(255,255,255,0.85)', fontSize: '15px' }}>{feature}</span>
              </div>
              <div className="p-5 flex items-center justify-center border-l" style={{ borderColor: 'rgba(255,255,255,0.08)' }}>
                {perch ? (
                  <CheckCircle2 className="w-6 h-6" style={{ color: '#B0F18D' }} />
                ) : (
                  <span style={{ color: 'rgba(255,255,255,0.3)', fontSize: '18px' }}>—</span>
                )}
              </div>
              <div className="p-5 flex items-center justify-center border-l" style={{ borderColor: 'rgba(255,255,255,0.08)' }}>
                {traditional ? (
                  <CheckCircle2 className="w-6 h-6" style={{ color: 'rgba(255,255,255,0.3)' }} />
                ) : (
                  <span style={{ color: 'rgba(255,255,255,0.3)', fontSize: '18px' }}>—</span>
                )}
              </div>
            </div>
          ))}

        </div>

        {/* CTA — below table */}
        <div className="flex flex-col sm:flex-row items-center justify-center mt-8 gap-8">
          <span className="font-semibold" style={{ color: 'rgba(255,255,255,0.5)', fontSize: '15px' }}>
            Ready to switch?
          </span>
          <Link to="/plans">
            <button
              className="font-semibold rounded-[11px] px-8 h-[48px]"
              style={{ backgroundColor: '#B0F18D', color: '#000000', fontSize: '15px' }}
            >
              Get A Plan
            </button>
          </Link>
        </div>

      </div>
    </section>
  );
};

export default ComparisonTable;
